import { useEffect } from 'react';
import { matchPath, useLocation } from "react-router-dom";
import ReactConfig from '@/router/config'
import useFetch from '@/api/useFetch';
import styles from './Banner.module.less'
import Carousel from '@/utils/carousel'
import { useTranslation } from 'react-i18next'
function Index({ history }) {
  const { i18n } = useTranslation()
  const { response = [] } = useFetch('getBanner')
  const location = useLocation()
  const isIndex = matchPath(location.pathname, ReactConfig.find(item => item.name === 'index'));

  useEffect(() => {
    if(response.length > 0) {
      Carousel('#banner', {
        rest: 3000,
        interval: 10,
        step: 50
      })
    }
  }, [response])

  return (
    <div className={`${styles.bannerWrap} ${isIndex ? styles.all : ''}`}>
      <div id="banner" className={styles.banner}>
        <ul className="carousel-pics">
        {
          response.map((i) => (
            <li key={i.qcmsdid}>
              <a href={i.url}>
                <img 
                  className="swiper-item" 
                  src={i.img_pc}
                  alt="lunbo"
                />
              </a>
            </li>
          ))
        }
        </ul>
        <ol className="carousel-pagin">
        </ol>
        <div className={styles.gradient} />
      </div>
    </div>
  );
}

export default Index;
